:host {
  display: block;
  width: 100%;
  user-select: none;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
}

.AppSwitcherSearch {
  display: flex;
  flex-direction: column;
  width: 100%;

  &__bar {
    position: relative;
    display: flex;
    align-items: center;
    gap: var(--pdt-space-200);
    width: 100%;

    pwc-icon-shadow {
      color: var(--pdt-color-text-disabled);
      position: absolute;
      inset-inline-start: var(--pdt-space-100);
      top: var(--pdt-space-75);
    }

    input {
      height: 32px;
      width: 100%;
      min-width: 200px;
      outline: 0;
      padding-block: var(--pdt-space-50);
      padding-inline: var(--pdt-space-400) var(--pdt-space-100);
      background-color: var(--pdt-color-control-bg);
      border: 1px solid var(--pdt-color-border);
      border-radius: var(--pdt-radius-75);
      font-family: inherit;
      font-size: var(--pdt-text-body-sm-font-size);
      line-height: var(--pdt-text-body-sm-line-height);
      color: var(--pdt-color-text);

      &:focus-visible {
        border-color: var(--pdt-color-border-focused);
        box-shadow: var(--pdt-shadow-focus);
      }

      &::placeholder {
        color: var(--pdt-color-text-disabled);
      }
    }
  }

  &__close-btn {
    display: none;
    color: var(--pdt-color-icon-alpha);
  }

  &__results {
    display: none;
    flex-direction: column;
    gap: var(--pdt-space-100);
    padding: var(--pdt-space-50) var(--pdt-space-200) var(--pdt-space-200);
    width: 100%;
  }

  &__group {
    display: flex;
    flex-direction: column;
  }

  &__item {
    display: flex;
    align-items: center;
    width: 100%;
    gap: var(--pdt-space-150);
    padding: var(--pdt-space-50) var(--pdt-space-100);
    border-radius: var(--pdt-radius-75);
    border: 1px solid transparent;
    cursor: pointer;
    text-decoration: none;
    color: var(--pdt-color-text);
    font-size: var(--pdt-text-body-sm-font-size);
    line-height: var(--pdt-text-body-sm-line-height);
    background-color: var(--pdt-color-bg-alpha-subtle);
    transition: all .2s ease;

    span {
      flex-grow: 1;
    }

    pwc-icon-shadow {
      opacity: 0;
      color: var(--pdt-color-text-medium);
    }

    &:hover {
      background-color: var(--pdt-color-bg-alpha-subtle-hovered);
    }

    &:hover,
    &:focus-visible {
      pwc-icon-shadow {
        opacity: 1;
      }
    }

    &:active {
      background-color: var(--pdt-color-bg-alpha-subtle-pressed);
    }

    &--user-active {
      &:hover {
        background-color: var(--pdt-color-bg-selected-hovered);
        color: var(--pdt-color-text-selected);

        pwc-icon-shadow {
          color: var(--pdt-color-text-selected);
        }
      }

      &:active {
        background-color: var(--pdt-color-bg-selected-pressed);
      }
    }

    &:focus-visible {
      outline: 0;
      border-color: var(--pdt-color-border-focused);
      box-shadow: var(--pdt-shadow-focus);
    }

    &--product {
      font-weight: var(--pdt-font-weight-semibold);
      margin-bottom: var(--pdt-space-50);
    }
  }

  eco-suite-navbar-menu-divider:last-child {
    display: none;
  }

  &__no-results {
    font-size: var(--pdt-text-body-sm-font-size);
    line-height: var(--pdt-text-body-sm-line-height);
    color: var(--pdt-color-text-subtle);
    padding: var(--pdt-space-200) var(--pdt-space-100);
    margin: 0;
  }

  /* Open state: show close button and results */
  &--open {
    .AppSwitcherSearch__bar {
      position: sticky;
      top: 0;
      inset-inline-start: 0;
      background-color: white;
      padding: var(--pdt-space-200) var(--pdt-space-150);

      pwc-icon-shadow {
        inset-inline-start: var(--pdt-space-250);
        top: 22px;
      }
    }

    .AppSwitcherSearch__close-btn {
      display: block;
    }

    .AppSwitcherSearch__results {
      display: flex;
    }
  }
}
